export const mockProducts = [
  {
    id: 1,
    name: {
      en: 'Bliss Corn Flakes',
      ar: 'رقائق الذرة بليس'
    },
    category: {
      en: 'Breakfast & Cereals',
      ar: 'الإفطار والحبوب'
    },
    image: 'https://customer-assets.emergentagent.com/job_9bdc54da-c0a9-4aea-9bd3-e8f1cd139c29/artifacts/0ufuffdi_CORN%20FLAKES%20-%20BLISS.jpg',
    description: {
      en: 'Premium quality corn flakes perfect for breakfast menus',
      ar: 'رقائق الذرة عالية الجودة مثالية لقوائم الإفطار'
    }
  },
  {
    id: 2,
    name: {
      en: 'Tate & Lyle Dark Brown Sugar',
      ar: 'سكر بني داكن تيت آند لايل'
    },
    category: {
      en: 'Baking Ingredients',
      ar: 'مكونات الخبز'
    },
    image: 'https://customer-assets.emergentagent.com/job_9bdc54da-c0a9-4aea-9bd3-e8f1cd139c29/artifacts/av3wr3cx_DARK%20BROWN%20SUGAR%20T%26L.jpg',
    description: {
      en: 'Premium dark brown sugar for baking and desserts',
      ar: 'سكر بني داكن ممتاز للخبز والحلويات'
    }
  },
  {
    id: 3,
    name: {
      en: 'Barilla Penne Rigate No.73',
      ar: 'باريلا بيني ريغاتي رقم 73'
    },
    category: {
      en: 'Pasta & Grains',
      ar: 'المعكرونة والحبوب'
    },
    image: 'https://customer-assets.emergentagent.com/job_9bdc54da-c0a9-4aea-9bd3-e8f1cd139c29/artifacts/7y4zwdaj_PENNE%20RIGATE%20NO.73%20BARILLA.jpeg',
    description: {
      en: 'Authentic Italian pasta from Barilla, perfect for all pasta dishes',
      ar: 'معكرونة إيطالية أصلية من باريلا، مثالية لجميع أطباق المعكرونة'
    }
  },
  {
    id: 4,
    name: {
      en: 'Rawan Whole Rolled Oats',
      ar: 'شوفان كامل روان'
    },
    category: {
      en: 'Breakfast & Cereals',
      ar: 'الإفطار والحبوب'
    },
    image: 'https://customer-assets.emergentagent.com/job_9bdc54da-c0a9-4aea-9bd3-e8f1cd139c29/artifacts/4w6wcp6y_RAWAN%20OATS.jpg',
    description: {
      en: 'Nutritious whole rolled oats for healthy breakfast options',
      ar: 'شوفان كامل مغذي لخيارات إفطار صحية'
    }
  },
  {
    id: 5,
    name: {
      en: 'Al Shafaa Natural Honey - 4kg Value Pack',
      ar: 'عسل طبيعي الشفاء - عبوة 4 كجم'
    },
    category: {
      en: 'Baking Ingredients',
      ar: 'مكونات الخبز'
    },
    image: 'https://customer-assets.emergentagent.com/job_taj-trading-oman/artifacts/i1cxywqq_1774252688186.png',
    description: {
      en: 'Premium quality natural honey in bulk packaging, perfect for hotels and restaurants',
      ar: 'عسل طبيعي عالي الجودة في عبوة كبيرة، مثالي للفنادق والمطاعم'
    }
  },
  {
    id: 6,
    name: {
      en: 'Al Shafaa Natural Honey - 500g',
      ar: 'عسل طبيعي الشفاء - 500 جرام'
    },
    category: {
      en: 'Baking Ingredients',
      ar: 'مكونات الخبز'
    },
    image: 'https://customer-assets.emergentagent.com/job_taj-trading-oman/artifacts/yeuga2qh_1774252827053.png',
    description: {
      en: 'Premium quality natural honey in convenient jar packaging',
      ar: 'عسل طبيعي عالي الجودة في عبوة مريحة'
    }
  },
  {
    id: 7,
    name: {
      en: 'Heavens Refined Olive Oil - 5L',
      ar: 'زيت زيتون مكرر هيفنز - 5 لتر'
    },
    category: {
      en: 'Condiments & Sauces',
      ar: 'التوابل والصلصات'
    },
    image: 'https://customer-assets.emergentagent.com/job_taj-trading-oman/artifacts/ligf2bx2_1774252876108.png',
    description: {
      en: 'Premium refined oils blended with extra virgin olive oil for cooking',
      ar: 'زيوت مكررة ممتازة ممزوجة بزيت الزيتون البكر للطبخ'
    }
  },
  {
    id: 8,
    name: {
      en: 'San Pellegrino Sparkling Water - 750ml',
      ar: 'مياه سان بيليغرينو الفوارة - 750 مل'
    },
    category: {
      en: 'Beverages',
      ar: 'المشروبات'
    },
    image: 'https://customer-assets.emergentagent.com/job_taj-trading-oman/artifacts/63l8wfsy_1774253054476.png',
    description: {
      en: 'Premium Italian carbonated natural mineral water, perfect for fine dining',
      ar: 'مياه معدنية طبيعية فوارة إيطالية ممتازة، مثالية للمطاعم الفاخرة'
    }
  },
  {
    id: 9,
    name: {
      en: 'MDH Deggi Mirch Chilli Powder',
      ar: 'مسحوق الفلفل الحار ديجي ميرش MDH'
    },
    category: {
      en: 'Condiments & Sauces',
      ar: 'التوابل والصلصات'
    },
    image: 'https://customer-assets.emergentagent.com/job_taj-trading-oman/artifacts/po2ryt8o_1774253881577.png',
    description: {
      en: 'Premium quality chilli powder for colorful and delicious dishes',
      ar: 'مسحوق فلفل حار عالي الجودة لأطباق ملونة ولذيذة'
    }
  },
  {
    id: 10,
    name: {
      en: 'Mara Italian Whole Peeled Tomatoes',
      ar: 'طماطم مقشرة كاملة إيطالية مارا'
    },
    category: {
      en: 'Condiments & Sauces',
      ar: 'التوابل والصلصات'
    },
    image: 'https://customer-assets.emergentagent.com/job_taj-trading-oman/artifacts/ropklre6_1774256302552.png',
    description: {
      en: 'Premium Italian whole peeled tomatoes, perfect for authentic Italian cuisine',
      ar: 'طماطم مقشرة كاملة إيطالية ممتازة، مثالية للمطبخ الإيطالي الأصيل'
    }
  },
  {
    id: 11,
    name: {
      en: 'Mara Tomato Paste 22/24%',
      ar: 'معجون طماطم مارا 22/24٪'
    },
    category: {
      en: 'Condiments & Sauces',
      ar: 'التوابل والصلصات'
    },
    image: 'https://customer-assets.emergentagent.com/job_taj-trading-oman/artifacts/ak8x9rqx_1774256452268.png',
    description: {
      en: 'Concentrated tomato paste, premium quality suitable for vegetarian dishes',
      ar: 'معجون طماطم مركز، جودة ممتازة مناسب للأطباق النباتية'
    }
  },
  {
    id: 12,
    name: {
      en: 'Vital 100% Pure Sunflower Oil - 5L',
      ar: 'زيت دوار الشمس النقي فيتال - 5 لتر'
    },
    category: {
      en: 'Condiments & Sauces',
      ar: 'التوابل والصلصات'
    },
    image: 'https://customer-assets.emergentagent.com/job_taj-trading-oman/artifacts/76qq76ff_1774256525802.png',
    description: {
      en: '100% pure sunflower oil in bulk packaging for commercial kitchens',
      ar: 'زيت دوار الشمس النقي 100٪ في عبوة كبيرة للمطابخ التجارية'
    }
  }
];

export const mockCategories = [
  { id: 1, name: { en: 'Breakfast & Cereals', ar: 'الإفطار والحبوب' }, count: 150 },
  { id: 2, name: { en: 'Pasta & Grains', ar: 'المعكرونة والحبوب' }, count: 120 },
  { id: 3, name: { en: 'Baking Ingredients', ar: 'مكونات الخبز' }, count: 200 },
  { id: 4, name: { en: 'Dairy Products', ar: 'منتجات الألبان' }, count: 180 },
  { id: 5, name: { en: 'Beverages', ar: 'المشروبات' }, count: 250 },
  { id: 6, name: { en: 'Condiments & Sauces', ar: 'التوابل والصلصات' }, count: 100 }
];

export const mockTestimonials = [
  {
    id: 1,
    name: { en: 'Ahmed Al Balushi', ar: 'أحمد البلوشي' },
    business: { en: 'Grand Hotel Muscat', ar: 'فندق جراند مسقط' },
    rating: 5,
    text: {
      en: 'Taj Gulf Trading has been our trusted supplier for 5 years. Their quality and service are exceptional.',
      ar: 'كانت تاج الخليج للتجارة موردنا الموثوق لمدة 5 سنوات. جودتهم وخدمتهم استثنائية.'
    }
  },
  {
    id: 2,
    name: { en: 'Fatima Al Lawati', ar: 'فاطمة اللواتي' },
    business: { en: 'Salalah Restaurant Chain', ar: 'سلسلة مطاعم صلالة' },
    rating: 5,
    text: {
      en: 'Reliable delivery and competitive pricing. They understand our business needs perfectly.',
      ar: 'التسليم الموثوق والأسعار التنافسية. يفهمون احتياجات أعمالنا تمامًا.'
    }
  },
  {
    id: 3,
    name: { en: 'Mohammed Al Hinai', ar: 'محمد الهنائي' },
    business: { en: 'Nizwa Cafe & Bakery', ar: 'مقهى ومخبز نزوى' },
    rating: 5,
    text: {
      en: 'The best in the business! Their product range and expert team make ordering easy.',
      ar: 'الأفضل في العمل! مجموعة منتجاتهم وفريقهم الخبير يجعلان الطلب سهلاً.'
    }
  }
];

export const whatsappConfig = {
  number: '96899378612',
  businessName: 'Taj Gulf Trading LLC',
  defaultMessage: {
    en: 'Hello Taj Gulf Trading LLC, I would like to inquire about your products.',
    ar: 'مرحبا تاج الخليج للتجارة، أود الاستفسار عن منتجاتكم.'
  }
};
